<template>
  <div>
    <v-app-bar
      id="top-bar"
      color="white"
      flat
      fixed
      app
      clipped-right
    >
      <v-btn icon @click="$router.go(-1)">
        <v-icon x-large color="black">mdi-chevron-left</v-icon>
      </v-btn>
      <v-img
        src="../assets/logo.svg"
        max-height="2.5em"
        max-width="50vw"
        position="left"
        contain
      />
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon>
        <v-btn icon @click="drawer = true">
          <v-icon large color="#000000">mdi-menu</v-icon>
        </v-btn>
      </v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      temporary
      right
    >
      <v-list
        nav
        dense
        flat
        class="text-right"
      >
        <!-- TODO: Make this into its own component! -->
        <v-list-item-group
          v-model="currentPage"
          active-class="highlight"
        >
          <v-list-item two-line value="Profile">
            <v-list-item-content>
              <v-list-item-title>{{ userName }}</v-list-item-title>
              <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar color="teal">
              <img v-if="userAvatar" :src="userAvatar">
              <span v-else style="color: white">{{ nameInitals }}</span>
            </v-list-item-avatar>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item value="Context" class="mt-2">
            <v-list-item-title class="text-subtitle-1">Roda da Vida</v-list-item-title>
            <v-list-item-icon>
              <v-icon>$vuetify.icons.rodavida</v-icon>
            </v-list-item-icon>
          </v-list-item>
          
          <v-list-item value="Notes">
            <v-list-item-title class="text-subtitle-1">Anotações</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-card-text</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item value="Actions">
            <v-list-item-title class="text-subtitle-1">Ações</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-calendar-check</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item value="Help">
            <v-list-item-title class="text-subtitle-1">Ajuda</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-help-circle</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item class="mt-10" value="Exit">
            <v-list-item-title class="text-subtitle-1" style="color: red;">Sair</v-list-item-title>
            <v-list-item-icon>
              <v-icon style="color: red;">mdi-exit-to-app</v-icon>
            </v-list-item-icon>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { G_SELECTED_CONTEXT, G_SELECTED_GROUP } from '@/store/modules/helpers/getter.type';
import { mapGetters } from "vuex";

export default {
  name: "TopBar",
  data: () => ({
    drawer: false,
    userName: "Desconhecido",
    userEmail: "",
    userAvatar: null,
    group: ""
  }),
  mounted() {
      this.userName = this.user?.displayName || "Desconhecido";
      this.userEmail = this.user?.email || "";
      this.userAvatar = this.user?.photoURL;
  },
  watch: {
    user() {
      this.userName = this.user?.displayName || "Desconhecido";
      this.userEmail = this.user?.email || "";
      this.userAvatar = this.user?.photoURL;
    }
  },
  computed: {
    nameInitals() {
      const parts = this.userName.split(" ");
      return parts[0][0] + (parts.length > 1 ? parts[parts.length-1][0] : "");
    },
    currentPage: {
      get() {
        return this.$route.name;
      },
      set(newVal) {
        switch (newVal) {
          case "Context":
            this.context();
            break;
          
          case "Notes":
            this.notes();
            break;
          
          case "Actions":
            this.actions();
            break;
          
          case "Profile":
            this.profile();
            break;
          
          case "Help":
            this.help();
            break;
          
          case "Exit":
            this.exit();
            break;
          
          default:
            console.error("Option not specified.");
        }
      }
    },
    group_id() { return this.$route.params.group_id || this.$store.getters[G_SELECTED_GROUP]; },
    context_id() { return this.$route.params.context_id || this.$store.getters[G_SELECTED_CONTEXT]; },
    params() {
      if (!this.group_id || !this.context_id) return null;
      return { group_id: this.group_id, context_id: this.context_id }
    },
    ...mapGetters([
      "loggedIn",
      "user",
    ])
  },
  methods: {
    defaultRoute() {
      this.$router.push({
        name: "Home"
      }).catch(() => {});
    },
    notes() {
      if (this.params) {
        if (this.$route.name !== "Notes") {
          this.$router.push({
            name: "Notes",
            params: this.params
          });
        }
      } else this.defaultRoute();
    },
    context() {
      if (this.params) {
        if (this.$route.name !== "Context") {
          this.$router.push({
            name: "Context",
            params: this.params
          });
        }
      } else this.defaultRoute();
    },
    profile() {
      if (this.$route.name !== "Profile") {
        this.$router.push({
          name: "Profile"
        });
      }
    },
    help() {
      if (this.$route.name !== "Help") {
        this.$router.push({
          name: "Help"
        });
      }
    },
    async exit() {
      await this.$store.dispatch("logout");
      this.$router.push({
        name: "Login"
      });
    },
    actions() {
      if (this.$route.name !== "Tasks") {
        this.$router.push({
          name: "Tasks"
        })
      }
    }
  }
};
</script>
<style lang="scss">
#top-bar {
  display: flex;
  flex-flow: column nowrap;
  
  &::after {
    content: " "; 
    margin: 0 1em;  
    display: block;
    border-top: 2px solid #CE3E17;
    border-bottom: 2px solid #CE3E17;
    border-radius: 2px;
  }
}
.highlight {
  color: #CE3E17 !important;
}
</style>
